import React from "react"
import {connect} from "react-redux"
import {purchaseTicket} from "../../actions/piano"
import ProgramStateConst from "../../common/variables/ProgramStateConst"
import { useTranslation } from "react-i18next";

function OfferPurchaseButton(props) {
    const { t } = useTranslation();

    let notice = t('offer.notice');
    if (props.isLocationNG){
        return getButton(props, t('ticketStatus.nonPurchasableArea') ,true, notice)
    }
    switch (props.programState) {
        case ProgramStateConst.purchased:
            return getButton(props, t('ticketStatus.purchased') ,true, notice)
        case ProgramStateConst.streaming:
            return "" // 何も表示しない
        case ProgramStateConst.done:
            return ""  // 何も表示しない
        case ProgramStateConst.waitSale:
            return "" // 何も表示しない
        case ProgramStateConst.unavailable:
            return "" // 何も表示しない
        case ProgramStateConst.onSale:
            return getButton(props, t('ticketStatus.purchaseTicket'), false, notice)
        case ProgramStateConst.cancelled:
            return ""
        default:
            return ""
    }
}

function getButton(props, body, isInvalidation, notice) {
    // 購入不可
    if (isInvalidation) {
        return (
            <>
            <dt className="detail-info__title before-live-only detail-header__date" style={{ textAlign: 'center' }}>{notice}</dt>
            <div
                className={props.isSP ? ('detail-side__buy-button before-live-only sp-only') : ('detail-side__buy-button before-live-only') }
                title={body}
                style={{cursor: "default"}}
            >
            {body}</div>
            </>
        )
    } else {
        // 購入可
        
        return (
            <>
            <dt className="detail-info__title before-live-only detail-header__date" style={{ textAlign: 'center' }}>{notice}</dt>
            <a
                className= {props.isSP ? ('detail-side__buy-button sp-only before-live-only') : ('detail-side__buy-button before-live-only') }
                title={body}
                onClick={() => {
                    props.purchaseTicket(props.offerId)
                }}
            >
            {body}</a>
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    purchaseTicket: (offerId) => dispatch(purchaseTicket(offerId)),
})

export default connect(null, mapDispatchToProps)(OfferPurchaseButton)
